module.exports = __webpack_public_path__ + "assets/img/pic.5672fd98.png";